export const EDIT_USER_FORM_NAME = 'EditUserFormName';
export const USER_FILTERS_FORM_NAME = 'UserFiltersFormName';
export const RESET_USER_PASSWORD_FORM_NAME = 'ResetNewPasswordForm';
export const IMAGE_FILTER_KEY_NAME = 'IMAGES';
export const DOMAIN_FILTER_KEY_NAME = 'DOMAINS';
export const REVIEW_FILTER_KEY_NAME = 'REVIEW';
export const QUALITY_FILTER_KEY_NAME = 'QUALITY_CONTROL';
export const SOCIAL_MEDIA_FILTER_KEY_NAME = 'SOCIAL_MEDIA';

export const USER_PERMISSIONS = [
  {
    id: 1,
    name: 'ADMIN',
    description: 'Administrator'
  },
  {
    id: 2,
    name: 'USER',
    description: 'User'
  }
];

export const USER_TABLE_COLUMNS = [
  {
    title: 'User name',
    dataIndex: 'name',
    key: 'username',
    // sorter: true,
    sorter: (a, b) => a.name.localeCompare(b.name)
    // sorter: (a, b) => a.username - b.username,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    // sorter: true,
    sorter: (a, b) => a.email.localeCompare(b.email)
    // sorter: (a, b) => a.email - b.email,
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    // sorter: true,
    sorter: (a, b) => a.role.localeCompare(b.role)
    // sorter: (a, b) => a.role - b.role,
  },
  {
    title: '',
    dataIndex: 'statusIcon',
    align: 'center',
    width: '20%',
    translate_key: 'status'
  },
  {
    title: 'Actions',
    dataIndex: 'editButton',
    align: 'center',
    width: '10%'
  }
];
